import type { GridConfig } from '@coursera-web/cds-labs';

export const TWO_COLUMN_ITEMS_GRID_CONFIG: GridConfig = { xs: 12, sm: 6, md: 4, lg: 4 };

export const OVERSIZED_COMPONENTS = [
  'PageConfig_PathwayRecommendationsComponent',
  'PageConfig_StandardRolesCollection',
  'PageConfig_SpotlightCollectionComponent',
  'PageConfig_CollectionComponent',
  'PageConfig_EmbeddedPromoTemplatePage',
  'PageConfig_EnterpriseBrowseCollectionComponent',
  'PageConfig_EnterpriseCuratedCollectionComponent',
  'PageConfig_EnterpriseLearningPaths',
  'PageConfig_GoogleProgramBanner',
];

export const ONBOARDING_HEADER_COMPONENTS = ['PageConfig_CoachOnboardingBanner', 'PageConfig_ModularOnboarding'];
